import { useContext } from 'react';
import { ViewerContext } from '../providers/CesiumProvider';
import * as Cesium from "cesium";
import useScenario from './useScenario';
import { update_sat_orbit_path } from './cesiumUtils';
import useTimeline from './useTimeline';
import useContacts from './useContacts';
import useUrlParams from './useUrlParams';

const useViewer = () => {
    const context = useContext(ViewerContext);
    if (context === undefined) {
        throw new Error('useViewer must be used within a ViewerProvider');
    }
    const { dashboard, scenario_id } = useUrlParams()
    const { viewer, set_current_simulation_time, current_simulation_time } = context;
    const { simulation_time, set_simulation_time } = useScenario()
    const { timeframe_details, set_timeframe_details } = useTimeline()
    const { get_time_based_gs_contact_details } = useContacts()

    const { start_time, end_time } = simulation_time
    const simulation_start_time = start_time * 1000
    const simulation_end_time = end_time * 1000

    const change_viewer_time = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(event.target.value);

        if (viewer) {
            const julianDate = Cesium.JulianDate.fromDate(new Date(newValue * 1000));
            const current_time = Cesium.JulianDate.toDate(julianDate).getTime();
            if (current_time >= simulation_start_time && current_time <= simulation_end_time) {
                viewer.clock.currentTime = julianDate;
                set_current_simulation_time(current_time)
                // update_sat_orbit_path(viewer, current_time)
            }
        }

    };


    function getCurrenttwentyfourSlot(startTime, endTime, duration, currentTime) {
        // Convert everything to numbers in case they're strings
        startTime = Number(startTime);
        endTime = Number(endTime);
        duration = Number(duration);
        currentTime = Number(currentTime) / 1000;

        // If currentTime is before start or after end, calculate appropriate slot
        if (currentTime < startTime || currentTime > endTime) {
            const slotIndex = Math.floor((currentTime - startTime) / duration);
            const frame_start_time = startTime + (slotIndex * duration);
            const frame_end_time = frame_start_time + duration;

            return { frame_start_time, frame_end_time };
        }

        // Otherwise, currentTime is within the original range
        // Find which slot it falls into
        const slotIndex = Math.floor((currentTime - startTime) / duration);
        const frame_start_time = startTime + (slotIndex * duration);
        const frame_end_time = frame_start_time + duration;

        return { frame_start_time, frame_end_time };
    }

    const go_live = () => {
        set_timeframe_details({
            ...timeframe_details,
            manual_change: false
        })

        if (dashboard === 'operate') {
            const { frame_start_time, frame_end_time } = getCurrenttwentyfourSlot(simulation_time.start_time, simulation_time.end_time, simulation_time.duration, current_simulation_time)
            set_simulation_time({
                start_time: frame_start_time,
                end_time: frame_end_time,
                duration: simulation_time.duration
            })
            get_time_based_gs_contact_details(scenario_id!, frame_start_time, frame_end_time, 'compact')
        }
    }

    return {
        ...context,
        change_viewer_time,
        go_live
    }
};

export default useViewer;